export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4829.4748c4c5.jpg";